var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-box",attrs:{"data-page-id":_vm.uuid,"id":_vm.uuid}},[(_vm.$store.state.dataLoadingStatus === true)?_c('CqLoading'):_c('Root')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }